import { Switch, SwitchProps } from "@mui/material/";

export const IosSwitch = (props: SwitchProps) => <Switch variant="ios" {...props} />;
